export enum ApiStatusCodes {
  TOKEN_RENEW_CODE = -22,
  EXCEPTION_RESPONSE = -21,
  USER_UNAUTHORIZED_CODE = -20,
}
